import { useState, type ChangeEvent, type FunctionComponent } from 'react';
import * as styles from './FillIn.module.css';

interface FillInProps {
  content?: string | null;
  onChange?: (newValue: string) => void;
}

const FillIn: FunctionComponent<FillInProps> = ({ content, onChange }) => {
  const [value, setValue] = useState(content || '');

  const valueChanged = (element: ChangeEvent<HTMLInputElement>) => {
    const newContent = element.target.value;
    setValue(newContent);
    onChange && onChange(newContent);
  };

  const placeholder = '';

  return (
    <input
      data-testid="fill-in"
      className={styles.fillIn}
      onChange={valueChanged}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default FillIn;
